export const storage = {
  set: (key: string, data: any) => {
    localStorage.setItem("stronghold:" + key, JSON.stringify(data));
  },
  get: (key: string): any => {
    const stored = localStorage.getItem("stronghold:" + key);
    return stored ? JSON.parse(stored) : undefined;
  },
};
